import PropTypes from 'prop-types'

import { HelpIcon } from '../../../components'
import {
  SectionCard,
  SectionHeader,
  SectionHeading,
  SectionHeadingHelp,
  SectionHeadingTail,
  SectionFootnote,
  SectionRows,
  SectionEmptyMessage,
  SectionNotice,
} from './DashboardStyle'

const AccountsSectionCard = ({ title, tooltip, footnote, notice, emptyMessage, children }) => {
  // Keep the help icon with the title's last word so it cannot wrap onto its own line.
  const lastWordStart = title.lastIndexOf(' ') + 1

  return (
    <SectionCard>
      <SectionHeader>
        <SectionHeading>
          {title.slice(0, lastWordStart)}
          <SectionHeadingTail>
            {title.slice(lastWordStart)}
            {tooltip && (
              <SectionHeadingHelp>
                <HelpIcon tooltip={tooltip} size='large' />
              </SectionHeadingHelp>
            )}
          </SectionHeadingTail>
        </SectionHeading>
        {footnote && <SectionFootnote>{footnote}</SectionFootnote>}
      </SectionHeader>
      {emptyMessage ? (
        <SectionEmptyMessage>{emptyMessage}</SectionEmptyMessage>
      ) : (
        <SectionRows>{children}</SectionRows>
      )}
      {notice && <SectionNotice>{notice}</SectionNotice>}
    </SectionCard>
  )
}

AccountsSectionCard.propTypes = {
  title: PropTypes.string.isRequired,
  tooltip: PropTypes.node,
  footnote: PropTypes.node,
  notice: PropTypes.node,
  emptyMessage: PropTypes.node,
  children: PropTypes.node,
}

export default AccountsSectionCard
